<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="isUpdate()"
          @on-complete="updatePqr"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('pqr.reception_data')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
              @setAllRequired="setAllRequired"
              @setAllNoRequired="setAllNoRequired"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.details')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content
            :title="$t('pqr.planner')"
            :before-change="() => validateStep('thirdStep')"
          >
            <third-step
              ref="thirdStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></third-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center">
              4.1 {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-8">
                <pqr-details-table
                  :pqrData="pqrFormData"
                  :isFromCreate="true"
                />
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <not-index-permissions v-else :operationType="'edit'" />
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { showContinue } from 'src/util/Util.js';
import FirstStep from './steps/FirstStep.vue';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import PqrTableDetails from '../PqrTableDetails.vue';
import SecondStep from './steps/SecondStep.vue';
import ThirdStep from './steps/ThirdStep.vue';

export default {
  components: {
    [PqrTableDetails.name]: PqrTableDetails,
    FirstStep,
    SecondStep,
    ThirdStep,
  },

  data() {
    return {
      pqrFormData: {},
    };
  },

  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  methods: {
    goToFirstStep() {
      this.$emit('setActiveTab', { ref: 'pqrsTabs', index: 0 });
      this.$router.push('/pqrs/pqrs/create');
    },

    cleanAllSteps() {
      this.$refs.firstStep.model = {
        ...this.$refs.firstStep.initialModel,
      };
      this.$refs.secondStep.model = {
        ...this.$refs.secondStep.initialModel,
      };
      this.$refs.thirdStep.model = {
        ...this.$refs.thirdStep.initialModel,
      };
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(_, model) {
      this.pqrFormData = { ...this.pqrFormData, ...model };
    },

    updatePqr() {
      this.showHideLoading(true);
      this.pqrFormData.route = 'pqrs/pqrs';

      this.pqrFormData.container_num = this.pqrFormData.container_num.replace(
        /\s|-/g,
        ''
      );

      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.pqrFormData.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;

          if (isset(this.$refs.thirdStep.model.evidence)) {
            if (!isset(this.$refs.thirdStep.model.fileList)) {
              this.pqrFormData.evidence = null;
            }
          } else {
            if (isset(this.$refs.thirdStep.model.fileList)) {
              this.pqrFormData.evidence = 'set';
            }
          }

          Axios.updateMaster(this.pqrFormData)
            .then((response) => {
              this.showHideLoading();

              if (isset(this.$refs.thirdStep.model.fileList)) {
                this.$refs.thirdStep.submitUpload();
              }

              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/pqrs/manages'
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },

    setAllRequired() {
      this.$refs['secondStep'].allRequired = true;
      this.$refs['thirdStep'].allRequired = true;
    },

    setAllNoRequired() {
      this.$refs['firstStep'].allRequired = false;
      this.$refs['secondStep'].allRequired = false;
      this.$refs['thirdStep'].allRequired = false;
    },
  },

  created() {
    this.showHideLoading();
  },

  mounted() {
    this.selectedItemOnMenu('pqrs');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    this.deselectedItemOnMenu('pqrs');
  },
};
</script>
